
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#FEF0C7"}}),_c('g',{attrs:{"clip-path":"url(#clip0_11338_16877)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.701 12.318c1.009-1.757 3.59-1.757 4.598 0l7.358 12.828C30.647 26.87 29.377 29 27.36 29H12.64c-2.017 0-3.287-2.13-2.299-3.854l7.36-12.828zm3.618 12.803c0 .714-.59 1.293-1.32 1.293a1.306 1.306 0 01-1.318-1.293c0-.714.59-1.293 1.319-1.293.728 0 1.319.579 1.319 1.293zm-1.32-10.344c-.727 0-1.318.579-1.318 1.293v3.879c0 .714.59 1.293 1.319 1.293.728 0 1.319-.58 1.319-1.293v-3.88c0-.713-.59-1.292-1.32-1.292z","fill":"#F79009"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11338_16877"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(10 10)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    